/**
 * Чем подтверждается имущество в заявлении (ТЗ корректировок, 16.10.2026).
 *
 * Значения стоят в творительном падеже: они встают во фразы «Данная
 * информация подтверждается …» и «данные сведения подтверждаются …».
 * Здесь, а не в генераторе: тот же список нужен интерфейсу для выбора.
 */

/** Варианты для выбора — те же документы, что в перечне приложений. */
export const CONFIRMATION_OPTIONS = [
  'сведениями из ЕГРН',
  'выпиской из ЕГРН ФНС',
  'сведениями из ГИБДД',
  'сведениями из ГРТС',
  'справкой ГИМС',
  'справкой Гостехнадзора',
];

/** Формулировка образца для отсутствия (иного) имущества. */
export const DEFAULT_ABSENCE_CONFIRMATION =
  'выпиской из ЕГРН ФНС, сведениями из ГРТС, справками из ГИМС и Гостехнадзора';

/** Варианты для «чем подтверждается отсутствие» — образец и его части. */
export const ABSENCE_CONFIRMATION_OPTIONS = [
  DEFAULT_ABSENCE_CONFIRMATION,
  'выпиской из ЕГРН ФНС',
  'выпиской из ЕГРН ФНС и сведениями из ГРТС',
  'сведениями из ГРТС, справками из ГИМС и Гостехнадзора',
];

/** Документ по умолчанию, если юрист не выбрал свой. */
export function defaultConfirmation(section: 'realty' | 'vehicle', kind: string): string {
  if (section === 'realty') return 'сведениями из ЕГРН';
  if (kind === 'water') return 'справкой ГИМС';
  if (kind === 'agricultural') return 'справкой Гостехнадзора';
  return 'сведениями из ГИБДД';
}
